import LicenceFeeCard from '@/components/global-admin/pricing/LicenceFeeCard';

export default function LicenceFeesPage() {
  return (
    <div className="space-y-6" data-testid="licence-fees-page">
      <div>
        <h2 className="text-2xl font-bold tracking-tight">Licence fees</h2>
        <p className="text-muted-foreground">
          The monthly fee per tier for a server the customer runs themselves. A tier with no fee
          of its own falls back to small business.
        </p>
      </div>

      <LicenceFeeCard />
    </div>
  );
}
